import React from 'react';
import PropTypes from 'prop-types';
import format from '../../utils/format';

import { PROPERTY_TYPES } from '../../constants';

export function ListItemSummaryComponent({ type, property }) {
  const isBuilding = type === PROPERTY_TYPES.BUILDINGS;
  const sqft = isBuilding && property.sqft > 0 ? `${format(property.sqft)} SF` : '';
  const acres = !isBuilding && property.acres > 0 ? `${format(property.acres)} Acres` : '';
  const ceiling = isBuilding && property.ceilingHeight > 0
    ? `${format(property.ceilingHeight)} Ft Ceiling`
    : '';
  const regionSeparator = property.city.length > 0 && property.state.length > 0 ? ', ' : '';
  const buildingTypes = isBuilding && property.buildingType && property.buildingType.length
    ? property.buildingType.join(', ')
    : '';
  const size = sqft || acres;
  const ftDataSeparator = size && ceiling ? ' | ' : '';
  const description = `${size}${ftDataSeparator}${ceiling}`;
  const suiteOrUnit = property['basicInfo.location.suite'] || property.unit || null;

  return (
    <div className="listItemSummary">
      {property.name &&
        <h3>{property.name}</h3>
      }
      <h4>
        {suiteOrUnit && <div>Suite {suiteOrUnit}</div> }
        {property.city}{regionSeparator}{property.state}
      </h4>
      {buildingTypes.length > 0 && <h4>{property.buildingType.join(', ')}</h4>}
      {property.type > 0 && <h4>{property.type}</h4>}
      {description.length > 0 && <h4>{description}</h4>}
      {/* {property.leaseRate && <h4>Lease Rate: {property.leaseRate}</h4>}
      {property.salePrice && <h4>Sale Price: {property.salePrice}</h4>} */}
    </div>
  );
}

ListItemSummaryComponent.propTypes = {
  type: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
};

export default ListItemSummaryComponent;




// WEBPACK FOOTER //
// ./src/components/List/ListItemSummary.js